import React, { useEffect, useRef } from "react";

interface ColorPickerProps {
  x: number;
  y: number;
  onClose: () => void;
  onColorSelect: (color: string) => void;
}

const HIGHLIGHT_COLORS = [
  "#fffad7", // 노란색
  "#e7f5ff", // 파란색
  "#ffe5f8", // 빨간색
];

const ColorPicker: React.FC<ColorPickerProps> = ({
  x,
  y,
  onClose,
  onColorSelect,
}) => {
  const pickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={pickerRef}
      className="fixed z-50 flex gap-1 p-2 bg-white border border-gray-300 rounded-lg shadow-lg"
      style={{ left: x, top: y }}
    >
      {HIGHLIGHT_COLORS.map((color, index) => (
        <button
          key={index}
          className="w-8 h-8 rounded-full border border-gray-400 hover:scale-110 transition-transform"
          style={{ backgroundColor: color }}
          onClick={() => {
            onColorSelect(color);
          }}
          title={`Highlight color ${index + 1}`}
        />
      ))}
    </div>
  );
};

export default ColorPicker;
